import { Avatar, Box, Grid, StyleRules, withStyles } from '@material-ui/core';
import React, { Component } from 'react'
import Slider from 'react-slick';
import back from "../assets/card_background.png"
// import rank from "../assets/rank427319694.png";
// import Girl from "../assets/girlEllipse 655.png";
import Quotes from "../assets/ColorQuote-removebg-preview.png";
import Adarsh from "../assets/Adarsh Shiare 1.png";
import Sonam from "../assets/sonamgroup.png";
import Himanshu from "../assets/Himanshu_Joshi.jpg";
import Nimish from "../assets/Nimish_Vikhar.jpeg";
import Lily from "../assets/Lily Ora.jpg";
import Aayush from "../assets/ayush_joshi_QA-removebg-preview 2.png";
import Sudhanshu from "../assets/sudhanshugroup.png";
import Gourav from "../assets/Gourav Dubey 2.png";

interface Props {
    classes: any
}

class ClientCarousel extends Component<Props>{
    render() {
        const { classes } = this.props;

        const settings = {
            // className: "center",
            // centerMode: true,
            // centerPadding: "60px",
            // dots: true,
            // // arrows:false,    
            // infinite: true,
            // speed: 500,
            // slidesToShow: 3,
            // slidesToScroll: 3,
            // autoplay: true,
            // autoplaySpeed: 2000,
            // slidesPerRow: 1,
            dots: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            speed: 8000,
            autoplaySpeed: 2000,
            cssEase: "linear",
            // prevArrow: null,
            // nextArrow: null,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,

                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 3,
                    }
                },
            ],
        }

        return (
            <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12} className={classes.clientGrid}>
                    {/* <Box className={`${classes.clientHeading} ${classes.secondHeading}`}>Client Testimonial</Box> */}
                    <Box className={`${classes.clientHeading} ${classes.secondHeading}`}>Student Testimonial</Box>
                    <Box className={classes.clientParagraph}>
                        Our institute takes pride in the success of our students who have secured top positions in various IT companies. These students have displayed exceptional skills and knowledge in their respective fields. Their achievements are a testament to the quality of education and training provided by our institute.
                    </Box>
                    <Box className={classes.clientSlick}>
                        {/* <Box className={classes.sliderContainer}> */}
                        <Slider {...settings} className={classes.clientCaro}>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={Quotes} alt="rank" className={classes.cardRankImg} />
                                </Box>
                                <Box className={classes.cardName}>Adarsh Sihare</Box>
                                <Box className={classes.cardDesignation}>ReactJS Developer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Adarsh} alt="img" />
                                </Box>
                                {/* <Box className={classes.cardTitle}>
                                    The institute provides an excellent environment for learning and personal growth.
                                </Box> */}
                                {/* <Box className={classes.cardDescription}>
                                    I would like to share my feedback on the incredibly beneficial Assertiveness Skills Course I attended during my 6-month training period at Codezzy. This course has had a profound impact on both my work and personal life, bringing about positive changes that I am truly grateful for. The skills and tips I learned during the course have been incredibly valuable, and I have been able to apply them with remarkable results almost immediately.I must commend Total Success for providing an exceptional experience from start to finish.
                                </Box> */}
                                <Box className={classes.cardDescription}>
                                    Codezzy has transformed my learning experience! Their courses, supportive community, and practical projects have accelerated my coding skills.
                                </Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={Quotes} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Himanshu Joshi</Box>
                                <Box className={classes.cardDesignation}>React Native Developer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Himanshu} alt="img" />
                                </Box>
                                {/* <Box className={classes.cardTitle}>
                                    One of the best Institute in Indore.
                                </Box> */}
                                {/* <Box className={classes.cardDescription}>
                                    An enriched learning culture and a motivation to perform better than yesterday is, what taught at codezzy institute. I appreciate and recommend codezzy.I highly recommend Codezzy Institute to anyone who is looking for a quality education that will prepare them for success in their chosen field. The institute's dedication to providing a comprehensive education, combined with its commitment to student success, makes it an excellent choice for anyone who wants to achieve their goals and make a positive impact on society.
                                </Box> */}
                                <Box className={classes.cardDescription}>
                                    Codezzy provided hands-on projects, comprehensive tutorials, and supportive mentors, making my coding journey enjoyable and rewarding.
                                </Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={Quotes} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Aayush Joshi</Box>
                                <Box className={classes.cardDesignation}>Quality Assurance Analyst</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Aayush} alt="img" />
                                </Box>
                                {/* <Box className={classes.cardTitle}>
                                    Atmosphere is full of motivation and innovation.
                                </Box> */}
                                {/* <Box className={classes.cardDescription}>
                                    I completed a course in this institute and I have to say the instructor effectively explained complex coding concepts.Coding can be a challenging subject, and it requires a clear understanding of the underlying concepts to be able to write efficient and effective code. The instructor's ability to effectively explain these complex concepts is a valuable asset, and it can make a significant difference in a student's ability to master coding skills.
                                </Box> */}
                                <Box className={classes.cardDescription}>
                                    Codezzy doesn’t just teach you how to code; it teaches you how to think like a programmer. The problem-solving skills I developed through their interactive exercises have been invaluable in my professional pursuits.
                                </Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={Quotes} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Sonam Asati</Box>
                                <Box className={classes.cardDesignation}>ReactJS Developer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Sonam} alt="img" />
                                </Box>
                                {/* <Box className={classes.cardTitle}>
                                    It is a great honor for me to be a part of this institute.
                                    </Box> */}
                                {/* <Box className={classes.cardDescription}>
                                    It has been a most enriching experience. I would like to thank the faculty and management team for their professional guidance which provided me the requisite skills to do well in industry. I had a great experience with Codezzy and would highly recommend it to anyone looking for quality web development training. Thank you, Codezzy, for providing such a wonderful learning experience.
                                    </Box> */}
                                <Box className={classes.cardDescription}>
                                    Codezzy provided me with comprehensive coding resources and guidance. The interactive lessons and supportive community empowered me to master programming skills effectively and efficiently.
                                </Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={Quotes} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Nimish Vikhar</Box>
                                <Box className={classes.cardDesignation}>React Native Developer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Nimish} alt="img" />
                                </Box>
                                {/* <Box className={classes.cardTitle}>
                                    Best experience, it's great to be a part of this institute.
                                </Box> */}
                                {/* <Box className={classes.cardDescription}>
                                    I am satisfied with the training and training faculty at Codezzy. They have well designed courses with practical orientation to get great exposure in the business corporate.Teaching is good, more focus given on basics so that the concepts are clear. Assignments are useful, and provided clarity about facing interviews. Thank you team Codezzy!
                                </Box> */}
                                <Box className={classes.cardDescription}>
                                    As a Beginner, I appreciate Codezzy’s step-by-step method. The modules helped me through the learning process, and I’ve noticed a betterment in my coding skills since beginning the programme.
                                </Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={Quotes} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Sudhanshu Singh</Box>
                                <Box className={classes.cardDesignation}>Quality Assurance Analyst</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Sudhanshu} alt="img" />
                                </Box>
                                {/* <Box className={classes.cardTitle}>
                                    The faculty members are highly qualified and experienced.
                                </Box> */}
                                {/* <Box className={classes.cardDescription}>
                                    I had a fantastic learning experience at Codezzy Institute. The instructors were highly knowledgeable and supportive, providing me with the necessary skills and guidance to excel in my chosen field. The hands-on approach and real-world projects helped me gain practical experience and boosted my confidence. The institute's state-of-the-art facilities and collaborative learning environment fostered a positive and engaging atmosphere. I highly recommend Codezzy Institute to anyone looking to acquire valuable technical skills and embark on a successful career in the tech industry
                                </Box> */}
                                <Box className={classes.cardDescription}>
                                    Thanks to Codezzy, I was able to pursue a profession in software development. The real-world projects and coding difficulties helped me prepare for interviews and provided the practical skills I needed to succeed.
                                </Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={Quotes} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Gourav Dubey</Box>
                                <Box className={classes.cardDesignation}>ReactJS Developer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Gourav} alt="img" />
                                </Box>
                                {/* <Box className={classes.cardTitle}>
                                    Efficient Work Environment with User-Friendly Features.
                                </Box> */}
                                {/* <Box className={classes.cardDescription}>
                                    The training was excellent, with engaging interactions and valuable knowledge sharing. The recording facility was especially helpful for revising the course material.The mentor, demonstrated a deep understanding of the subject matter and explained it with enthusiasm. The course not only provided practical and informative content but also boosted my confidence. I gained valuable experiences and learned a lot throughout the course.
                                </Box> */}
                                <Box className={classes.cardDescription}>
                                    Codezzy’s has been a game changer for me. The interactive tutorials and hands-on projects have helped me understand complicated coding topics fast and efficiently.
                                </Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={Quotes} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Lily Ora</Box>
                                <Box className={classes.cardDesignation}>React Native Developer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Lily} alt="img" />
                                </Box>
                                {/* <Box className={classes.cardTitle}>
                                    A Fantastic Learning Experience.
                                </Box> */}
                                {/* <Box className={classes.cardDescription}>
                                    Faculties give personal attention to each student, simplified learning and brilliant experience. Thank you codezzy for grooming and fit me for this corporate world.The institute's approach to education is unique, and it encourages students to think critically, solve problems creatively, and innovate. The faculty members are highly qualified and experienced, and they are always willing to go the extra mile to ensure that students receive the best possible education.
                                </Box> */}
                                <Box className={classes.cardDescription}>
                                    Codezzy’s user-friendly interface and comprehensive tutorials made it easy for me, even as a complete beginner. I highly recommend it to anyone looking to learn how to code.
                                </Box>
                            </Box>
                        </Slider>
                        {/* <Slider {...settings} className={classes.clientCaro}>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={rank} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Paul Patterson</Box>
                                <Box className={classes.cardDesignation}>UI/UX Designer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Girl} alt="img" />
                                </Box>
                                <Box className={classes.cardTitle}>Amazing Customer Service</Box>
                                <Box className={classes.cardDescription}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis dicta, eligendi dolor, quibusdam deserunt.</Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={rank} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Paul Patterson</Box>
                                <Box className={classes.cardDesignation}>UI/UX Designer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Girl} alt="img" />
                                </Box>
                                <Box className={classes.cardTitle}>Amazing Customer Service</Box>
                                <Box className={classes.cardDescription}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis dicta, eligendi dolor, quibusdam deserunt.</Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={rank} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Paul Patterson</Box>
                                <Box className={classes.cardDesignation}>UI/UX Designer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Girl} alt="img" />
                                </Box>
                                <Box className={classes.cardTitle}>Amazing Customer Service</Box>
                                <Box className={classes.cardDescription}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis dicta, eligendi dolor, quibusdam deserunt.</Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={rank} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Paul Patterson</Box>
                                <Box className={classes.cardDesignation}>UI/UX Designer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Girl} alt="img" />
                                </Box>
                                <Box className={classes.cardTitle}>Amazing Customer Service</Box>
                                <Box className={classes.cardDescription}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis dicta, eligendi dolor, quibusdam deserunt.</Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={rank} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Paul Patterson</Box>
                                <Box className={classes.cardDesignation}>UI/UX Designer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Girl} alt="img" />
                                </Box>
                                <Box className={classes.cardTitle}>Amazing Customer Service</Box>
                                <Box className={classes.cardDescription}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis dicta, eligendi dolor, quibusdam deserunt.</Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={rank} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Paul Patterson</Box>
                                <Box className={classes.cardDesignation}>UI/UX Designer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Girl} alt="img" />
                                </Box>
                                <Box className={classes.cardTitle}>Amazing Customer Service</Box>
                                <Box className={classes.cardDescription}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis dicta, eligendi dolor, quibusdam deserunt.</Box>
                            </Box>
                        </Slider> */}
                        {/* <Slider {...settings} className={classes.clientCaro}>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={rank} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Paul Patterson</Box>
                                <Box className={classes.cardDesignation}>UI/UX Designer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Girl} alt="img" />
                                </Box>
                                <Box className={classes.cardTitle}>Amazing Customer Service</Box>
                                <Box className={classes.cardDescription}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis dicta, eligendi dolor, quibusdam deserunt.</Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={rank} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Paul Patterson</Box>
                                <Box className={classes.cardDesignation}>UI/UX Designer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Girl} alt="img" />
                                </Box>
                                <Box className={classes.cardTitle}>Amazing Customer Service</Box>
                                <Box className={classes.cardDescription}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis dicta, eligendi dolor, quibusdam deserunt.</Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={rank} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Paul Patterson</Box>
                                <Box className={classes.cardDesignation}>UI/UX Designer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Girl} alt="img" />
                                </Box>
                                <Box className={classes.cardTitle}>Amazing Customer Service</Box>
                                <Box className={classes.cardDescription}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis dicta, eligendi dolor, quibusdam deserunt.</Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={rank} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Paul Patterson</Box>
                                <Box className={classes.cardDesignation}>UI/UX Designer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Girl} alt="img" />
                                </Box>
                                <Box className={classes.cardTitle}>Amazing Customer Service</Box>
                                <Box className={classes.cardDescription}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis dicta, eligendi dolor, quibusdam deserunt.</Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={rank} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Paul Patterson</Box>
                                <Box className={classes.cardDesignation}>UI/UX Designer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Girl} alt="img" />
                                </Box>
                                <Box className={classes.cardTitle}>Amazing Customer Service</Box>
                                <Box className={classes.cardDescription}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis dicta, eligendi dolor, quibusdam deserunt.</Box>
                            </Box>
                            <Box className={classes.card}>
                                <Box className={classes.cardRank}>
                                    <img src={rank} alt="rank" />
                                </Box>
                                <Box className={classes.cardName}>Paul Patterson</Box>
                                <Box className={classes.cardDesignation}>UI/UX Designer</Box>
                                <Box className={classes.cardImgBody}>
                                    <Avatar className={classes.cardImage} src={Girl} alt="img" />
                                </Box>
                                <Box className={classes.cardTitle}>Amazing Customer Service</Box>
                                <Box className={classes.cardDescription}>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis dicta, eligendi dolor, quibusdam deserunt.</Box>
                            </Box>
                        </Slider> */}
                    </Box>
                </Grid>
            </Grid>
        )
    }
}

const style: StyleRules =
    ({
        clientGrid: {
            width: "100%",
            backgroundColor: "white",
        },

        clientHeading: {
            // width: "220px",
            width: "235px",
            textAlign: "center",
            margin: "20px auto",
            fontSize: "25px",
            fontWeight: 700,
            fontFamily: "Nunito",
            borderBottom: "2px solid #EFB6B6",
        },

        clientParagraph: {
            width: "1170px",
            margin: "auto",
            padding: "10px 0px ",
            fontSize: "17px",
            fontWeight: 600,
            fontFamily: "Nunito",
            textAlign: "center",
        },

        slickSlide: {
            width: "200px"
        },

        clientSlick: {
            // backgroundColor: "red",
        },

        clientCaro: {
            // "& .slick-slider": {
            margin: "0px 20px",
            // },

            // "& .slick-track": {
            //     // transform: "none !important",
            // },

            "& .slick-prev": {
                display: "none !important",
                left: "0px",
            },

            "& .slick-next": {
                display: "none !important",
                right: "0px",
            },

            "& .slick-slide": {
                "& >*:nth-child(1)": {
                    width: "400px !important",
                    // height: "100%",
                    height: "461px",
                    background: `url(${back})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                    margin: "10px auto",
                    padding: "20px 40px",
                    borderRadius: "15px !important",
                    textAlign: "center",
                },
            },
        },

        //     backgroundColor: "red",
        //     width: "1170px",
        //     margin: "auto",
        //     padding: "50px 0px",

        //     // "& .slick-list": {
        //     //     width: "100%",
        //     //     padding: "0px !important",
        //     //     display: "flex",
        //     //     justifyContent: "center"
        //     // },

        //     // "& .slick-track": {
        //     //     width: "1170px !important",
        //     //     display: "flex",
        //     //     justifyContent: "space-evenly",
        //     // },

        //     // "& .slick-slide": {
        //     //     width: "300px !important",
        //     //     // margin: "0px 50px",
        //     //     "& > *:nth-child(1)": {
        //     //         width: "300px",
        //     //     },
        //     // },

        //     // "& .slick-dots": {
        //     //     bottom: "0px"
        //     // }
        // },

        // card: {
        //     width: "100% !important",
        //     background: `url(${back})`,
        //     backgroundPosition: "center",
        //     backgroundSize: "cover",
        //     padding: "40px",
        //     textAlign: "center",
        //     borderRadius: "15px !important",
        // },

        cardRank: {
            // width: "100%",
            width: "80px !important",
            height: "60px !important",
            // color: "rgba(237, 242, 243, 0.5) !important",
            opacity: 0.1,
            // display: "flex",
            // justifyContent: "center",
            "& img": {
                width: "100%",
                height: "100%",
            },
        },

        // cardRankImg: {
        //     width: "100%",
        //     height: "100%",
        // },

        cardName: {
            fontSize: "26px",
            fontWeight: 600,
            fontFamily: "Nunito",
            margin: "0px 0px"
        },

        cardDesignation: {
            fontSize: "12px",
            fontWeight: 700,
            fontFamily: "Nunito",
            margin: "5px 0px"
        },

        cardImgBody: {
            width: "120px",
            height: "120px",
            display: "flex",
            justifyContent: "center",
            margin: "15px auto",
            backgroundColor: "white",
            borderRadius: "50%",
        },

        cardImage: {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "top",
        },

        cardTitle: {
            fontSize: "14px",
            fontWeight: 500,
            fontFamily: "Roboto",
            margin: "35px 0px 0px",
            textAlign: "center",
        },

        cardDescription: {
            height: "100%",
            margin: "35px 0px",
            fontSize: "14px",
            fontWeight: 400,
            fontFamily: "Roboto",
        },

        // "@media screen and (min-width: 1024px) and (max-width: 1440px)": {
        //     clientCaro: {
        //         width: "900px",
        //         height: "500px",
        //         overflow: "hidden",
        //         margin: "auto",

        //         "& .slick-list": {
        //             width: "100%",
        //             padding: "0px !important"
        //         },

        //         "& .slick-track": {
        //             width: "900px",
        //             display: "flex",
        //             justifyContent: "space-evenly",
        //         },

        //         "& .slick-slide": {
        //             width: "250px !important",
        //             margin: "0px 30px",
        //             "& > *:nth-child(1)": {
        //                 width: "250px",
        //             },
        //         },
        //     },

        //     card: {
        //         padding: "30px 10px",
        //     },

        //     cardName: {
        //         fontSize: "22px",
        //         margin: "5px 0px"
        //     },

        //     cardDesignation: {
        //         margin: "0px 0px"
        //     },

        //     cardDescription: {
        //         fontSize: "12px"
        //     },
        // },

        // "@media screen and (min-width: 768px) and (max-width: 1023px)": {
        //     clientCaro: {
        //         width: "700px",
        //         height: "500px",
        //         overflow: "hidden",
        //         margin: "auto",

        //         "& .slick-list": {
        //             width: "100%",
        //             padding: "0px !important"
        //         },

        //         "& .slick-track": {
        //             width: "700px",
        //             display: "flex",
        //             justifyContent: "space-evenly",
        //         },

        //         "& .slick-slide": {
        //             width: "250px !important",
        //             margin: "0px 40px",
        //             "& > *:nth-child(1)": {
        //                 width: "250px",
        //             },
        //         },
        //     },

        //     card: {
        //         padding: "30px 10px",
        //     },

        //     cardName: {
        //         fontSize: "22px",
        //         margin: "5px 0px"
        //     },

        //     cardDesignation: {
        //         margin: "0px 0px"
        //     },

        //     cardDescription: {
        //         fontSize: "12px"
        //     },
        // },

        // "@media screen and (min-width: 576px) and (max-width: 767px)": {
        //     clientCaro: {
        //         width: "500px",
        //         height: "500px",
        //         overflow: "hidden",
        //         margin: "auto",

        //         "& .slick-list": {
        //             width: "100%",
        //             padding: "0px !important"
        //         },

        //         "& .slick-track": {
        //             width: "500px",
        //             display: "flex",
        //             justifyContent: "space-evenly",
        //         },

        //         "& .slick-slide": {
        //             width: "250px !important",
        //             margin: "0px 40px",
        //             "& > *:nth-child(1)": {
        //                 width: "250px",
        //             },
        //         },
        //     },

        //     card: {
        //         padding: "30px 10px",
        //     },

        //     cardName: {
        //         fontSize: "22px",
        //         margin: "5px 0px"
        //     },

        //     cardDesignation: {
        //         margin: "0px 0px"
        //     },

        //     cardDescription: {
        //         fontSize: "12px"
        //     },
        // },

        // "@media screen and (min-width: 300px) and (max-width: 575px)": {
        //     clientCaro: {
        //         width: "300px",
        //         height: "500px",
        //         overflow: "hidden",
        //         margin: "auto",

        //         "& .slick-list": {
        //             width: "100%",
        //             padding: "0px !important"
        //         },

        //         "& .slick-track": {
        //             width: "300px",
        //             display: "flex",
        //             justifyContent: "space-evenly",
        //         },

        //         "& .slick-slide": {
        //             width: "250px !important",
        //             margin: "0px 40px",
        //             "& > *:nth-child(1)": {
        //                 width: "250px",
        //             },
        //         },
        //     },

        //     card: {
        //         padding: "30px 10px",
        //     },

        //     cardName: {
        //         fontSize: "22px",
        //         margin: "5px 0px"
        //     },

        //     cardDesignation: {
        //         margin: "0px 0px"
        //     },

        //     cardDescription: {
        //         fontSize: "12px"
        //     },
        // },
    })

export default withStyles(style)(ClientCarousel)